module.exports = __webpack_public_path__ + "static/img/chengdu.75c55b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chengdu.png
// module id = 60b/
// module chunks = 1